import {useCachedVariants} from "~/components/server/useCachedVariants";

export function readLocalStorage() {
    if (import.meta.client) {
        // Read values from local storage
        const prefix = localStorage.getItem('prefix');
        const firstName = localStorage.getItem('firstName');
        const lastName = localStorage.getItem('lastName');
        const street = localStorage.getItem('street');
        const postcode = localStorage.getItem('postcode');
        const city = localStorage.getItem('city');

        // Create an object with the retrieved values
        return {
            prefix: prefix,
            firstName: firstName,
            lastName: lastName,
            street: street,
            postcode: postcode,
            city: city,
        };
    }
    return {};
}

export function getSortedOrders(orders: any) {
    if (orders && orders.length > 0) {
        orders.sort((a: any, b: any) => b.orderNumber - a.orderNumber);
    }
    return orders
}

export function removeProductById(productId: any, products: any) {

    for (let i = 0; i < products.length; i++) {
        if (products[i].id === productId) {
            products.splice(i, 1);
            break; // Exit the loop after removing the product
        }
    }

    return products;
}

export async function recreateCart() {
    const storedPersonData = localStorage.getItem('unPaidCart');
    if (typeof storedPersonData === "string") {
        const cartItems = JSON.parse(storedPersonData);

        for (const item of cartItems) {
            const { addToCart, isInCart, quantity } = useAddToCart(item);
            quantity.value = item.quantity;
            if(!isInCart.value) {
                await addToCart();
            }
        }
    }
}

export function rearrangeArray(array: any) {
    // Move '2nd image' (index 1) to the start
    array.splice(0, 0, array.splice(1, 1)[0]);

    if (array.length === 3) {
        // Move 'Third image' (index 2) to the second position
        array.splice(1, 0, array.splice(2, 1)[0]);
    }

    return array;
}

// Function to escape regular expression characters in sanitized words
function escapeRegExp(string: any) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

export function combineData(propertyGroups: any, propertyGroupOptions: any) {
    const combinedData: any = {};

    for (const group of propertyGroups) {
        const groupId = group?.id;
        const groupName = group?.translated?.name;

        const matchedOptions = propertyGroupOptions.filter((option: any) => option?.groupId === groupId);

        if (matchedOptions.length > 0) {
            combinedData[groupName] = matchedOptions.map((option: any) => option.translated.name).join(', ');
        }
    }

    return combinedData;
}

export async function getSizesObject(optionGroups: any, productId: any) {

    const sizeObject = optionGroups.value[0];
    if(!productId) {
        return sizeObject;
    }
    const variantData = await useCachedVariants(productId)
    if (sizeObject) {
        sizeObject.options.forEach((sizeOption: any) => {
            if(variantData) {
                const matchingVariant = variantData?.find((variant: any) => {
                    return variant?.optionIds.includes(sizeOption.id);
                });

                if (matchingVariant) {
                    sizeOption.stock = matchingVariant.stock;
                }
            }
        });
    }
    return sizeObject;
}